// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/metismenu/dist/metisMenu.css
// module id = 22
// module chunks = 0